import {
  IconCheckouts,
  IconInbox,
  IconMail,
  IconPlanning,
  IconProfilePlacementUser,
  IconUser,
  IconUsers,
} from 'assets/img';
import { PARTNER_PATHS } from 'partner/paths';
import { useTranslation } from 'react-i18next';
import { LogoutIcon, LogoutLabel } from './sidebar-logout';
import { getPlacementsDefaultFilter } from './utils';

export const useSidebarItems = () => {
  const { t } = useTranslation('partner-screen-specific');

  return [
    {
      ...PARTNER_PATHS.ShiftsPlanning,
      label: t('sidebar.planning'),
      icon: <IconPlanning />,
    },
    {
      ...PARTNER_PATHS.Placement,
      path: `${PARTNER_PATHS.Placement.path}${getPlacementsDefaultFilter()}`,
      label: t('sidebar.placements'),
      icon: <IconProfilePlacementUser />,
    },
    {
      ...PARTNER_PATHS.Inbox,
      label: t('sidebar.inbox'),
      icon: <IconMail />,
    },
    {
      ...PARTNER_PATHS.Checkout,
      label: t('sidebar.checkouts'),
      icon: <IconInbox />,
    },
    {
      ...PARTNER_PATHS.CheckedOut,
      label: t('sidebar.checked_out'),
      icon: <IconCheckouts />,
    },
    {
      ...PARTNER_PATHS.Worker,
      label: t('sidebar.workers'),
      icon: <IconUsers />,
    },
  ] as const;
};

export const useProfileInfo = () => {
  const { t } = useTranslation('partner-screen-specific');

  return {
    name: t('sidebar.profile'),
    children: [
      {
        key: 'profile',
        label: t('sidebar.profile'),
        icon: <IconUser />,
      },
      {
        key: 'logout',
        label: <LogoutLabel />,
        icon: <LogoutIcon />,
      },
    ],
  };
};
